<template>
  <div class="auth">
    <div class="auth__header">
      <div class="auth__header-logo">
        <img src="/img/logo.svg" alt="" />
      </div>
      <el-switch
        v-if="isLanguageSwitchAvailable"
        v-model="language"
        class="switch-language"
        active-text="EN"
        inactive-text="DE"
      />
    </div>

    <router-view />

    <!-- eslint-disable-next-line vue/no-bare-strings-in-template -->
    <div class="auth__footer body-4">© OÖML</div>
  </div>
</template>

<script setup>
import { ref, watch, computed } from 'vue'
import i18n from '@/lang/index.js'

const isLanguageSwitchAvailable = computed(() => {
  return import.meta.env.VITE_LANGUAGE_SWITCH_AVAILABLE
})

const language = ref(localStorage.getItem('language') === 'en' ? true : false)

watch(language, () => {
  if (isLanguageSwitchAvailable.value) {
    i18n.global.locale = language.value ? 'en' : 'de'
    localStorage.setItem('language', i18n.global.locale)
  }
})
</script>
